/* eslint-disable require-yield,no-console,no-undef */
import { put, takeEvery } from 'redux-saga/effects';

function* progressE(action) {
    let { onSound } = action.payload;
    yield put({
        type: 'ON_SOUND',
        payload: !onSound
    });
}

function* SagaOnSound() {
    yield takeEvery('SAGA_ON_SOUND', progressE);
}

export default SagaOnSound;



// WEBPACK FOOTER //
// ./src/redux/saga/actions/SagaOnSound.js